// extracted by mini-css-extract-plugin
export default {"memberSection":"People_memberSection__6haWM","peopleContainer":"People_peopleContainer__J9jB+","profilePic":"People_profilePic__WW+lJ","designation":"People_designation__oe-BZ"};